package com.daytimegaming.ourdailyfinances.domain.model

data class PortfolioHistoryEntry(
    val date: String,
    val value: Double
)

data class PortfolioHistory(
    val history: List<PortfolioHistoryEntry>
)

data class SecurityPerformance(
    val history: Map<String, List<PortfolioHistoryEntry>>
)

data class PlaidPricesSync(
    val jobId: String?,
    val tickers: List<String>,
    val source: String,
    val status: String
)
